import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { layout } from '../../themes/smartinventoryTheme';

// Sibling of PermissionState for the plan-gated case: the feature exists,
// the company's plan just doesn't include it. Locked-not-hidden by design —
// discoverability is the upsell.
const UpgradeState = ({ title, description, action, secondaryAction }) => (
  <Box sx={{ textAlign: 'center', py: 5, px: 3 }} data-testid="upgrade-state">
    <Box
      sx={{
        width: layout.stateIconSize,
        height: layout.stateIconSize,
        borderRadius: '50%',
        bgcolor: 'primary.light',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 1.5,
      }}
    >
      <LockOutlinedIcon color="primary" />
    </Box>
    <Typography variant="subtitle1">{title}</Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 420, mx: 'auto' }}>
        {description}
      </Typography>
    )}
    {(action || secondaryAction) && (
      <Box sx={{ mt: 2, display: 'flex', gap: 1.25, justifyContent: 'center' }}>
        {action && <Button variant="contained" onClick={action.onClick}>{action.label}</Button>}
        {secondaryAction && <Button variant="text" onClick={secondaryAction.onClick}>{secondaryAction.label}</Button>}
      </Box>
    )}
  </Box>
);

export default UpgradeState;
